import { useState } from 'react';

export function usePrevious<T>(value: T) {
  const [v] = useState({ value });
  v.value = value;
  return v;
}
